import { SegmentDataStructureType } from "@redotech/redo-model/marketing/segments/segment-data-structures";
import {
  ListCompare,
  ListCompareOperators,
} from "@redotech/redo-model/segments/segment-where-condition";
import { memo } from "react";
import { RedoListItem } from "../../../arbiter-components/list/redo-list";
import { RedoSingleSelectDropdownInput } from "../../../arbiter-components/select-dropdown/redo-single-select-dropdown-input";
import { MultipleTokenOptionSelect } from "./token-filter";

const listCompareOperatorToFriendly: Record<ListCompareOperators, string> = {
  [ListCompareOperators.ANY]: "include any of",
  [ListCompareOperators.NONE]: "include none of",
  [ListCompareOperators.ALL]: "have all of",
};

const listCompareOptions: RedoListItem<ListCompareOperators>[] = Object.values(
  ListCompareOperators,
).map((value) => ({
  id: value,
  text: listCompareOperatorToFriendly[value],
  value,
  type: "text",
}));

import { CustomerDataSource } from "@redotech/redo-model/marketing/segments/segment-types";

export const TokenListFilter = memo(function TokenListFilter({
  comparison,
  setComparison,
  dimension,
  fieldSource,
  dataStructure,
}: {
  comparison: ListCompare<string>;
  setComparison: (condition: ListCompare<string>) => void;
  dimension: string;
  fieldSource?: CustomerDataSource;
  dataStructure: SegmentDataStructureType;
}) {
  return (
    <>
      <RedoSingleSelectDropdownInput<ListCompareOperators>
        fitToAnchor={false}
        flexGrow={false}
        options={listCompareOptions}
        optionSelected={({ item }) => {
          setComparison({ ...comparison, operator: item.value });
        }}
        selectedItem={listCompareOptions.find(
          (item) => item.id === comparison.operator,
        )}
        size="xs"
      />
      <MultipleTokenOptionSelect
        dataStructure={dataStructure}
        dimension={dimension}
        fieldSource={fieldSource}
        key={dimension}
        selectedValues={comparison.values}
        setSelectedValues={(values) => {
          setComparison({ ...comparison, values });
        }}
      />
    </>
  );
});
